import { fetchExcursionTypes } from './fetchExcursionTypes';
import { fetchRiskCategories } from './fetchRiskCategories';
import { createExcursion } from './createExcursion';
import { syncExcursion } from './syncExcursion';

export default {
  fetchExcursionTypes,
  fetchRiskCategories,
  createExcursion,
  syncExcursion
};
